module.exports = __webpack_public_path__ + "img/marmelaedchen-schmetterling_xs.1f409589.jpg";